import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { EmblaOptionsType } from 'embla-carousel';
import NewAndOfferDetails from '@/features/news-and-offers/components/NewAndOfferDetails';
import { useNewsAndOffersListApi } from '@/features/news-and-offers/hooks/useNewsAndOffersListApi';
import DashboardNewsAndOffersCard from './DashboardNewsAndOffersCard';
import ECarousel from '@/components/everridge/carousel/ECarousel';
import useMediaQuery from '@/hooks/useMediaQuery';
import { AppConfig } from '@/config/app.config';
import { cn } from '@/lib/utils';

const OPTIONS: EmblaOptionsType = {
	align: 'start',
	dragFree: true,
	loop: true,
};

const DashboardNewsAndOffers = () => {
	const [newAndOfferId, setNewAndOfferId] = useState('');
	const [showNewAndOfferDetails, setShowNewAndOfferDetails] = useState(false);

	const isMobile = useMediaQuery(AppConfig.mediaQueries.mobile);
	const navigate = useNavigate();
	const { t } = useTranslation();

	const { newsAndOffersListData, isLoadingNewsAndOffersListData } =
		useNewsAndOffersListApi({
			take: 10,
		});

	if (!newsAndOffersListData?.length) return null;

	const handleShowDetails = (id: string) => {
		setNewAndOfferId(id);
		setShowNewAndOfferDetails(true);
	};

	return (
		<div
			className={cn(
				'p-6 flex flex-col gap-6 border border-popover-100 rounded-2.5xl bg-popover-10 select-none',
				isMobile &&
					'max-w-[calc(100vw-32px)] p-0 border-0 bg-popover-30 gap-4',
			)}>
			<div className={'h-11 flex items-center justify-between'}>
				<h4
					className={cn(
						'text-xl font-medium',
						isMobile && 'text-lg font-medium',
					)}>
					{t('main.dashboard.components.newsAndOffers.title')}
				</h4>
				<Button
					variant='outline'
					onClick={() => navigate('/news-and-offers')}>
					{t('main.dashboard.components.newsAndOffers.seeMoreButton')}
				</Button>
			</div>
			<div className='w-full'>
				<ECarousel
					// buttonsPosition='bottom'
					// buttonsSize='icon'
					options={OPTIONS}>
					{!isLoadingNewsAndOffersListData &&
						!!newsAndOffersListData.length &&
						newsAndOffersListData.map((el) => (
							<DashboardNewsAndOffersCard
								key={el.id}
								{...el}
								showDetails={handleShowDetails}
								isMobile={isMobile}
							/>
						))}
				</ECarousel>
			</div>
			{showNewAndOfferDetails && (
				<NewAndOfferDetails
					id={newAndOfferId}
					onClose={() => setShowNewAndOfferDetails(false)}
				/>
			)}
		</div>
	);
};

export default DashboardNewsAndOffers;
